import React, { useState } from "react";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaGraduationCap,
  FaArrowRight,
  FaPaperPlane,
  FaChevronRight,
  FaClock,
  FaAward,
  FaBookOpen,
  FaShieldAlt,
  FaStar,
  FaCheckCircle,
  FaGlobe,
} from "react-icons/fa";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const [email, setEmail] = useState("");
  const [newsletterMessage, setNewsletterMessage] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState("idle");

  const school = {
    name: "Salvation In Christ School System",
    tagline: "Excellence • Integrity • Innovation",
    email: "salvationinchristschoolsystem@gmail.com",
    phones: ["+231-776-4940-10", "+231-880-5858-55"],
    address: "Zazay Community, Paynesville City, Monrovia",
  };

  const quickLinks = [
    { label: "Home", href: "#home" },
    { label: "About Us", href: "#about" },
    { label: "Admissions", href: "#admissions" },
    { label: "Academic Programs", href: "#academics" },
    { label: "Student Portal", href: "#student-portal" },
  ];

  const academicLinks = [
    { label: "Online Results", href: "#results" },
    { label: "Attendance System", href: "#attendance" },
    { label: "Learning Management", href: "#learning" },
    { label: "School Calendar", href: "#calendar" },
    { label: "Parent Portal", href: "#parent-portal" },
  ];

  const socialLinks = [
    {
      label: "Facebook",
      icon: <FaFacebookF />,
      href: null,
    },
    {
      label: "Twitter",
      icon: <FaTwitter />,
      href: null,
    },
    {
      label: "Instagram",
      icon: <FaInstagram />,
      href: null,
    },
    {
      label: "LinkedIn",
      icon: <FaLinkedinIn />,
      href: null,
    },
  ];

  const styles = `
    .jana-footer {
      --jf-purple: #54218f;
      --jf-deep: #35105f;
      --jf-deeper: #260844;
      --jf-gold: #f4c542;
      --jf-gold-dark: #dca91c;
      --jf-white: #ffffff;
      --jf-muted: #d2c6e1;

      position: relative;
      overflow: hidden;
      background: var(--jf-deeper);
      color: var(--jf-white);
      font-family: inherit;
    }

    .jana-footer *,
    .jana-footer *::before,
    .jana-footer *::after {
      box-sizing: border-box;
    }

    .jana-footer a {
      -webkit-tap-highlight-color: transparent;
    }

    .jana-footer-accent {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      height: 5px;
    }

    .jana-footer-accent span:first-child {
      background: var(--jf-purple);
    }

    .jana-footer-accent span:nth-child(2) {
      background: var(--jf-gold);
    }

    .jana-footer-accent span:last-child {
      background: #8150bb;
    }

    .jana-footer-main {
      position: relative;
      display: grid;
      grid-template-columns: 1.3fr 1fr 1fr 1.2fr;
      gap: 42px;
      max-width: 1450px;
      margin: 0 auto;
      padding: 78px 6% 64px;
    }

    .jana-footer-main::before {
      content: "";
      position: absolute;
      top: 0;
      right: -120px;
      width: 300px;
      height: 300px;
      border: 50px solid rgba(255, 255, 255, 0.025);
      border-radius: 50%;
      pointer-events: none;
    }

    .jana-footer-brand {
      display: flex;
      align-items: flex-start;
      gap: 15px;
      margin-bottom: 24px;
    }

    .jana-footer-brand-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 58px;
      height: 58px;
      flex-shrink: 0;
      border: 1px solid rgba(244, 197, 66, 0.35);
      border-radius: 17px;
      background: linear-gradient(145deg, #63309b, #40116f);
      color: var(--jf-gold);
      font-size: 28px;
      box-shadow: 0 9px 24px rgba(0, 0, 0, 0.16);
    }

    .jana-footer-brand-text {
      min-width: 0;
      padding-top: 2px;
    }

    .jana-footer-brand-text h2 {
      margin: 0 0 8px;
      color: #ffffff;
      font-size: 18px;
      font-weight: 850;
      line-height: 1.45;
      letter-spacing: -0.3px;
      overflow-wrap: anywhere;
    }

    .jana-footer-brand-text span {
      display: block;
      color: var(--jf-gold);
      font-size: 10px;
      font-weight: 800;
      line-height: 1.7;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    .jana-footer-description {
      margin: 0;
      color: var(--jf-muted);
      font-size: 12.5px;
      line-height: 2;
    }

    .jana-footer-values {
      display: flex;
      flex-wrap: wrap;
      gap: 9px;
      margin-top: 25px;
    }

    .jana-footer-value {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      padding: 8px 10px;
      border: 1px solid rgba(255, 255, 255, 0.09);
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.045);
      color: #f1e8fc;
      font-size: 10px;
      font-weight: 700;
    }

    .jana-footer-value svg {
      color: var(--jf-gold);
      font-size: 12px;
    }

    .jana-footer-social-area {
      margin-top: 30px;
    }

    .jana-footer-social-heading {
      display: block;
      margin-bottom: 13px;
      color: #ffffff;
      font-size: 11px;
      font-weight: 800;
      letter-spacing: 0.7px;
    }

    .jana-footer-social-links {
      display: flex;
      flex-wrap: wrap;
      gap: 9px;
    }

    .jana-footer-social-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 39px;
      height: 39px;
      border: 1px solid rgba(255, 255, 255, 0.14);
      border-radius: 11px;
      background: rgba(255, 255, 255, 0.055);
      color: #ffffff;
      font-size: 15px;
      text-decoration: none;
      transition:
        transform 0.25s ease,
        background 0.25s ease,
        color 0.25s ease,
        border-color 0.25s ease;
    }

    .jana-footer-social-link:hover {
      transform: translateY(-3px);
      border-color: var(--jf-gold);
      background: var(--jf-gold);
      color: var(--jf-deep);
    }

    .jana-footer-column,
    .jana-footer-contact-section {
      position: relative;
      z-index: 1;
      min-width: 0;
    }

    .jana-footer-column-title {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 5px 0 27px;
    }

    .jana-footer-title-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      flex-shrink: 0;
      border-radius: 11px;
      background: rgba(244, 197, 66, 0.12);
      color: var(--jf-gold);
      font-size: 15px;
    }

    .jana-footer-column-title h3 {
      margin: 0;
      color: #ffffff;
      font-size: 14px;
      font-weight: 850;
      line-height: 1.5;
    }

    .jana-footer-list {
      display: grid;
      gap: 17px;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .jana-footer-list li {
      min-width: 0;
    }

    .jana-footer-list a {
      display: inline-flex;
      align-items: flex-start;
      gap: 10px;
      color: var(--jf-muted);
      font-size: 12px;
      line-height: 1.6;
      text-decoration: none;
      transition: color 0.2s ease, transform 0.2s ease;
    }

    .jana-footer-list a svg {
      flex-shrink: 0;
      margin-top: 4px;
      color: var(--jf-gold);
      font-size: 9px;
      transition: transform 0.2s ease;
    }

    .jana-footer-list a:hover {
      transform: translateX(3px);
      color: #ffffff;
    }

    .jana-footer-list a:hover svg {
      transform: translateX(2px);
    }

    .jana-footer-contact-grid {
      display: grid;
      gap: 19px;
    }

    .jana-footer-contact-card {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      min-width: 0;
    }

    .jana-footer-contact-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      flex-shrink: 0;
      border: 1px solid rgba(244, 197, 66, 0.2);
      border-radius: 10px;
      background: rgba(244, 197, 66, 0.08);
      color: var(--jf-gold);
      font-size: 13px;
    }

    .jana-footer-contact-copy {
      min-width: 0;
      padding-top: 1px;
    }

    .jana-footer-contact-copy > span {
      display: block;
      margin-bottom: 5px;
      color: #ffffff;
      font-size: 11px;
      font-weight: 800;
    }

    .jana-footer-contact-copy p,
    .jana-footer-contact-copy a {
      display: block;
      margin: 0;
      color: var(--jf-muted);
      font-size: 11.5px;
      line-height: 1.8;
      overflow-wrap: anywhere;
    }

    .jana-footer-contact-copy a {
      text-decoration: none;
      transition: color 0.2s ease;
    }

    .jana-footer-contact-copy a:hover {
      color: var(--jf-gold);
    }

    .jana-footer-newsletter-section {
      padding: 0 6% 38px;
    }

    .jana-footer-newsletter-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 30px;
      max-width: 1330px;
      margin: 0 auto;
      padding: 28px 30px;
      border: 1px solid rgba(244, 197, 66, 0.18);
      border-radius: 18px;
      background: linear-gradient(
        110deg,
        rgba(84, 33, 143, 0.62),
        rgba(62, 20, 103, 0.9)
      );
    }

    .jana-footer-newsletter-copy {
      display: flex;
      align-items: center;
      gap: 17px;
      min-width: 0;
    }

    .jana-footer-newsletter-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 51px;
      height: 51px;
      flex-shrink: 0;
      border-radius: 15px;
      background: var(--jf-gold);
      color: var(--jf-deep);
      font-size: 21px;
    }

    .jana-footer-newsletter-copy h3 {
      margin: 0 0 6px;
      color: #ffffff;
      font-size: 17px;
      font-weight: 850;
    }

    .jana-footer-newsletter-copy p {
      margin: 0;
      color: var(--jf-muted);
      font-size: 12px;
      line-height: 1.8;
    }

    .jana-footer-newsletter-form {
      display: flex;
      width: min(100%, 445px);
      gap: 9px;
      flex-shrink: 0;
    }

    .jana-footer-newsletter-form input {
      width: 100%;
      min-width: 0;
      height: 47px;
      padding: 0 15px;
      border: 1px solid rgba(255, 255, 255, 0.16);
      border-radius: 10px;
      outline: none;
      background: rgba(255, 255, 255, 0.09);
      color: #ffffff;
      font: inherit;
      font-size: 12px;
      transition: border-color 0.2s ease, background 0.2s ease;
    }

    .jana-footer-newsletter-form input::placeholder {
      color: #cbbbdc;
    }

    .jana-footer-newsletter-form input:focus {
      border-color: var(--jf-gold);
      background: rgba(255, 255, 255, 0.13);
    }

    .jana-footer-newsletter-form button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      min-width: 124px;
      height: 47px;
      padding: 0 15px;
      border: none;
      border-radius: 10px;
      background: var(--jf-gold);
      color: var(--jf-deep);
      font: inherit;
      font-size: 12px;
      font-weight: 850;
      cursor: pointer;
      transition: background 0.2s ease, transform 0.2s ease;
    }

    .jana-footer-newsletter-form button:hover {
      transform: translateY(-2px);
      background: #ffdc72;
    }

    .jana-footer-newsletter-form button:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
    }

    .jana-footer-newsletter-message {
      max-width: 1330px;
      margin: 10px auto 0;
      color: #f4d875;
      font-size: 12px;
      line-height: 1.6;
    }

    .jana-footer-motto {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 18px;
      padding: 21px 6% 27px;
    }

    .jana-footer-motto span {
      width: 48px;
      height: 1px;
      flex-shrink: 0;
      background: rgba(244, 197, 66, 0.55);
    }

    .jana-footer-motto p {
      margin: 0;
      color: #f2d98e;
      font-size: 11px;
      font-weight: 800;
      line-height: 1.8;
      letter-spacing: 1.4px;
      text-align: center;
      text-transform: uppercase;
    }

    .jana-footer-bottom {
      border-top: 1px solid rgba(255, 255, 255, 0.09);
      background: rgba(0, 0, 0, 0.17);
    }

    .jana-footer-bottom-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      max-width: 1450px;
      margin: 0 auto;
      padding: 23px 6%;
    }

    .jana-footer-copyright {
      margin: 0;
      color: #c5b5d7;
      font-size: 11px;
      line-height: 1.8;
    }

    .jana-footer-copyright strong {
      color: #ffffff;
      font-weight: 750;
    }

    .jana-footer-bottom-links {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }

    .jana-footer-bottom-links a {
      color: #c5b5d7;
      font-size: 10.5px;
      text-decoration: none;
      transition: color 0.2s ease;
    }

    .jana-footer-bottom-links a:hover {
      color: var(--jf-gold);
    }

    .jana-footer-bottom-links span {
      color: rgba(255, 255, 255, 0.23);
      font-size: 10px;
    }

    .jana-footer a:focus-visible,
    .jana-footer button:focus-visible {
      outline: 3px solid var(--jf-gold);
      outline-offset: 3px;
    }

    @media (max-width: 1200px) {
      .jana-footer-main {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 42px 35px;
      }

      .jana-footer-newsletter-inner {
        align-items: flex-start;
        flex-direction: column;
      }

      .jana-footer-newsletter-form {
        width: 100%;
      }
    }

    @media (max-width: 650px) {
      .jana-footer-main {
        grid-template-columns: minmax(0, 1fr);
        gap: 38px;
        padding: 56px 6% 43px;
      }

      .jana-footer-newsletter-section {
        padding: 0 5% 25px;
      }

      .jana-footer-newsletter-inner {
        gap: 22px;
        padding: 23px 19px;
      }

      .jana-footer-newsletter-copy {
        align-items: flex-start;
        gap: 13px;
      }

      .jana-footer-newsletter-copy h3 {
        font-size: 16px;
      }

      .jana-footer-newsletter-form {
        flex-direction: column;
      }

      .jana-footer-newsletter-form button {
        width: 100%;
      }

      .jana-footer-motto {
        gap: 10px;
        padding: 22px 5%;
      }

      .jana-footer-motto span {
        width: 20px;
      }

      .jana-footer-motto p {
        font-size: 9px;
        letter-spacing: 0.8px;
      }

      .jana-footer-bottom-inner {
        align-items: flex-start;
        flex-direction: column;
        padding: 23px 6%;
      }

      .jana-footer-bottom-links {
        justify-content: flex-start;
        gap: 8px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .jana-footer-social-link,
      .jana-footer-list a,
      .jana-footer-list a svg,
      .jana-footer-contact-copy a,
      .jana-footer-newsletter-form input,
      .jana-footer-newsletter-form button,
      .jana-footer-bottom-links a {
        transition: none !important;
      }
    }
  `;

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();

    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      setNewsletterStatus("error");
      setNewsletterMessage("Please enter your email address.");
      return;
    }

    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      normalizedEmail
    );

    if (!validEmail) {
      setNewsletterStatus("error");
      setNewsletterMessage("Please enter a valid email address.");
      return;
    }

    setNewsletterStatus("info");
    setNewsletterMessage(
      "Your email is valid, but newsletter subscriptions are not connected yet. Please connect this form to your newsletter API."
    );
  };

  return (
    <>
      <style>{styles}</style>

      <footer className="jana-footer">
        <div className="jana-footer-accent" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <div className="jana-footer-main">
          {/* SCHOOL BRAND */}
          <section className="jana-footer-brand-section">
            <div className="jana-footer-brand">
              <div className="jana-footer-brand-icon">
                <FaGraduationCap aria-hidden="true" />
              </div>

              <div className="jana-footer-brand-text">
                <h2>{school.name}</h2>
                <span>{school.tagline}</span>
              </div>
            </div>

            <p className="jana-footer-description">
              Empowering students through quality education,
              technology-driven learning, and a nurturing environment
              that prepares future leaders for academic excellence,
              responsible citizenship, and lifelong success.
            </p>

            <div className="jana-footer-values">
              <div className="jana-footer-value">
                <FaAward aria-hidden="true" />
                <span>Excellence</span>
              </div>

              <div className="jana-footer-value">
                <FaBookOpen aria-hidden="true" />
                <span>Knowledge</span>
              </div>

              <div className="jana-footer-value">
                <FaShieldAlt aria-hidden="true" />
                <span>Integrity</span>
              </div>
            </div>

            <div className="jana-footer-social-area">
              <span className="jana-footer-social-heading">
                Follow Our School
              </span>

              <div className="jana-footer-social-links">
                {socialLinks.map((social) =>
                  social.href ? (
                    <a
                      key={social.label}
                      className="jana-footer-social-link"
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                      title={social.label}
                    >
                      {social.icon}
                    </a>
                  ) : (
                    <span
                      key={social.label}
                      className="jana-footer-social-link"
                      aria-label={`${social.label} profile not configured`}
                      title={`${social.label} profile not configured`}
                      style={{ opacity: 0.55, cursor: "default" }}
                    >
                      {social.icon}
                    </span>
                  )
                )}
              </div>
            </div>
          </section>

          {/* QUICK LINKS */}
          <nav
            className="jana-footer-column"
            aria-label="Quick links"
          >
            <div className="jana-footer-column-title">
              <span className="jana-footer-title-icon">
                <FaArrowRight aria-hidden="true" />
              </span>

              <h3>Quick Links</h3>
            </div>

            <ul className="jana-footer-list">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href}>
                    <FaChevronRight aria-hidden="true" />
                    <span>{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* ACADEMIC LINKS */}
          <nav
            className="jana-footer-column"
            aria-label="Academic services"
          >
            <div className="jana-footer-column-title">
              <span className="jana-footer-title-icon">
                <FaBookOpen aria-hidden="true" />
              </span>

              <h3>Academic Services</h3>
            </div>

            <ul className="jana-footer-list">
              {academicLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href}>
                    <FaChevronRight aria-hidden="true" />
                    <span>{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* CONTACT INFORMATION */}
          <section className="jana-footer-contact-section">
            <div className="jana-footer-column-title">
              <span className="jana-footer-title-icon">
                <FaMapMarkerAlt aria-hidden="true" />
              </span>

              <h3>Contact Us</h3>
            </div>

            <div className="jana-footer-contact-grid">
              <div className="jana-footer-contact-card">
                <div className="jana-footer-contact-icon">
                  <FaMapMarkerAlt aria-hidden="true" />
                </div>

                <div className="jana-footer-contact-copy">
                  <span>Visit Our Campus</span>
                  <p>{school.address}</p>
                </div>
              </div>

              <div className="jana-footer-contact-card">
                <div className="jana-footer-contact-icon">
                  <FaPhoneAlt aria-hidden="true" />
                </div>

                <div className="jana-footer-contact-copy">
                  <span>Call Our Office</span>

                  {school.phones.map((phone) => (
                    <a
                      key={phone}
                      href={`tel:${phone.replace(/[^\d+]/g, "")}`}
                    >
                      {phone}
                    </a>
                  ))}
                </div>
              </div>

              <div className="jana-footer-contact-card">
                <div className="jana-footer-contact-icon">
                  <FaEnvelope aria-hidden="true" />
                </div>

                <div className="jana-footer-contact-copy">
                  <span>Email Our Team</span>

                  <a href={`mailto:${school.email}`}>
                    {school.email}
                  </a>
                </div>
              </div>

              <div className="jana-footer-contact-card">
                <div className="jana-footer-contact-icon">
                  <FaClock aria-hidden="true" />
                </div>

                <div className="jana-footer-contact-copy">
                  <span>Office Hours</span>
                  <p>Monday – Friday: 8:00 AM – 4:00 PM</p>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* NEWSLETTER */}
        <section className="jana-footer-newsletter-section">
          <div className="jana-footer-newsletter-inner">
            <div className="jana-footer-newsletter-copy">
              <div className="jana-footer-newsletter-icon">
                <FaEnvelope aria-hidden="true" />
              </div>

              <div>
                <h3>Stay Connected With Our School</h3>
                <p>
                  Get school news, important announcements, and event
                  updates delivered to your inbox.
                </p>
              </div>
            </div>

            <form
              className="jana-footer-newsletter-form"
              onSubmit={handleNewsletterSubmit}
              noValidate
            >
              <input
                type="email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);

                  if (newsletterStatus !== "idle") {
                    setNewsletterStatus("idle");
                    setNewsletterMessage("");
                  }
                }}
                placeholder="Enter your email address"
                aria-label="Email address for school newsletter"
                aria-describedby="jana-footer-newsletter-message"
                autoComplete="email"
                required
              />

              <button type="submit">
                Subscribe
                <FaPaperPlane aria-hidden="true" />
              </button>
            </form>
          </div>

          {newsletterMessage && (
            <p
              id="jana-footer-newsletter-message"
              className="jana-footer-newsletter-message"
              role="status"
              aria-live="polite"
            >
              {newsletterStatus === "error" ? (
                newsletterMessage
              ) : (
                <>
                  <FaCheckCircle
                    aria-hidden="true"
                    style={{ marginRight: 7 }}
                  />
                  {newsletterMessage}
                </>
              )}
            </p>
          )}
        </section>

        {/* SCHOOL MOTTO */}
        <div className="jana-footer-motto">
          <span aria-hidden="true" />

          <p>
            Building Character. Inspiring Excellence. Shaping the Future.
          </p>

          <span aria-hidden="true" />
        </div>

        {/* COPYRIGHT */}
        <div className="jana-footer-bottom">
          <div className="jana-footer-bottom-inner">
            <p className="jana-footer-copyright">
              © {currentYear} <strong>{school.name}</strong>.
              {" "}All Rights Reserved.
            </p>

            <nav
              className="jana-footer-bottom-links"
              aria-label="Legal and support links"
            >
              <a href="#privacy">Privacy Policy</a>
              <span aria-hidden="true">|</span>
              <a href="#terms">Terms &amp; Conditions</a>
              <span aria-hidden="true">|</span>
              <a href="#support">System Support</a>
            </nav>
          </div>
        </div>
      </footer>
    </>
  );
}
